import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { fetcher } from './fetchers';
import { LeaderboardsResults } from './components/leaderboards-results';
import { LeaderboardSponsorLogo } from './components/leaderboard-sponsor-logo';
import { useStyles } from './leaderboards-styles';
import { getLowestUnexpiredSegment, getNonZTime } from './helpers';
import LeaderboardHeader from './components/leaderboard-header';

export const LEADERBOARD_TYPES = [ 'open', 'youth', 'challenger', 'pro', 'limited'];
// export const LEADERBOARD_TYPES = [ 'open', 'youth', 'challenger', 'pro'];
export const SEGMENT_TYPES = {
  open: 'HasOpen',
  youth: 'HasYouth',
  challenger: 'HasChallenger',
  pro: 'HasPro',
  limited: 'HasLimited'
};

export const Leaderboards = () => {
  const classes = useStyles();
  const [segments, setSegments] = useState([]);
  const [selectedType, setSelectedType] = useState();
  const [selectedSegment, setSelectedSegment] = useState();
  const [loading, setLoading] = useState(true);
  const [typesList, setTypesList] = useState([]);

  const groupedSegmentsDefaults = {
    NominatableByYouth: true,
    Active: true,
    isGroupedSegment: true,
    HasPro: null,
    HasChallenger: null,
    HasOpen: true,
  }

  const groupedSegmentsConfig = [
    // {
    //   SegmentUID: [22,25,26,27],
    //   Name: 'Reliance Ranches VRQ Bonus 2022',
    //   ShortName: 'RRVB22',
    //   StartDate: '2022-04-11',
    //   EndDate: '2022-11-28',
    //   ...groupedSegmentsDefaults,
    // },
    // For the women website we dont use this segment
    // {
    //   SegmentUID: [26, 27, 28, 34],
    //   Name: 'Reliance Ranches VRQ Bonus 2023',
    //   ShortName: 'RRVB23',
    //   StartDate: '2022-11-28',
    //   EndDate: '2023-11-26',
    //   ...groupedSegmentsDefaults,
    // }
  ];

  const selectSegment = (typeSegments, SegmentUIDs)=> {
    const defaultSegments = typeSegments.filter((s) => s.DefaultSegment);
    const segUID = SegmentUIDs ? SegmentUIDs : defaultSegments.length > 0 ?
       defaultSegments[0].SegmentUID : getLowestUnexpiredSegment(typeSegments);
    const segment = typeSegments.find(seg => seg.SegmentUID.toString() === segUID.toString());
    setSegmentTypes(segment);
    setSelectedSegment(segment);
    const hasOpenOrChallenger = !!segment.HasOpen || !!segment.HasChallenger;
    const challengerOrOpen = segment.HasChallenger ? 'challenger' : 'open';
    setSelectedType(!hasOpenOrChallenger && !!segment.HasYouth ? 'youth' : challengerOrOpen);
  };

  const setActiveSegments = (allSegments, newType?) => {
    selectSegment(allSegments);
    setSegments(allSegments);
  };

  const setSegmentTypes = (segment) => {
    const types = LEADERBOARD_TYPES.reduce((types, type) => {
      segment[SEGMENT_TYPES[type]] && types.push(type);
      return types;
    },[])

    // if the segment has open, challenger, and pro set to true, do not show an open leaderboard, only pro and challenger
    const removeOpenTypes = [ 'open', 'challenger', 'pro', ];
    var containsAll = removeOpenTypes.every(type => types.includes(type));
    containsAll && types.splice(types.indexOf('open'),1);
    // This is the "hack" to show  "all around" as an options, add or remove if you want that option
    types.push('all');
    setTypesList(types);
  }

  const getGroupedSegments = (segments) => {
    return segments.reduce((acc, segment, i) => {
      acc.push(segment);
      groupedSegmentsConfig.forEach((groupedSegment) => {
        if (groupedSegment.SegmentUID.some(suid => suid === segment.SegmentUID)) {
          groupedSegment.WomensOnly = !!groupedSegment.WomensOnly ? groupedSegment.WomensOnly : segment.WomensOnly;
          groupedSegment.HasYouth = !!groupedSegment.HasYouth ? groupedSegment.HasYouth : segment.HasYouth;
        }
        if (segments.length === i+1) acc.push(groupedSegment);
      })

      return acc;
    }, []);
  };

  const getAllSegments = async (type?) => {
    //add &womensOnly=true  to deploy to the women's website
    fetcher(`get`, `/v1/segments?showExpiredSegments=true&womensOnly=true`)
      .then(
        (res) => {
          const segments = res.data;
          const sortedSegments = segments.sort((segment1, segment2) => {
            const segment1End = getNonZTime(segment1.EndDate);
            const segment2End = getNonZTime(segment2.EndDate);
            return segment1End - segment2End;
          });              
          const groupedSegments = getGroupedSegments(sortedSegments);
          
          setActiveSegments(groupedSegments, type);
        })
      .catch((error) => { throw error; });
  };

  useEffect(() => {
    getAllSegments();
  },[]);

  const Selectors = () => {
    return (
      <div class="position-list">
            <div class="leaderboard-selectors">
              <div class="leadboard-select-left">
                <span>SEGMENT:</span>
                <select id="segment-selection-react" onChange={(e) => selectSegment(segments, e.target.value)}>
                  {segments.map((segment) => (
                    <option
                      selected={selectedSegment.SegmentUID === segment.SegmentUID}
                      value={segment.SegmentUID.toString()}
                      key={segment.SegmentUID.toString()}
                    >
                      {`${segment.isGroupedSegment ? segment.Name : `Segment ${segment.ShortName}`}:
                      ${moment(segment.StartDate).utc().format('MM/DD/YY')} -
                      ${moment(segment.EndDate).utc().format('MM/DD/YY')}`}
                    </option>
                  ))}
                </select>
              </div>
              <div class="leadboard-select-right">
                <span>Type:</span>
                <select id="segment-selection-first" onChange={(e) => setSelectedType(e.target.value)}>
                  {typesList.map((type) => (
                    <option
                      selected={selectedType === type}
                      value={type}
                      key={type}
                    >{type === 'all' ? 'all around' : type }</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
    );
  }

  // This is the version used by the women's website that has a different template structure
  // when deploying here: https://wrwc.rodeo/wrwc-leaderboard/
  // use this version 

  return (
    <>
      <LeaderboardHeader>
        <Selectors />
      </LeaderboardHeader>
      <div class="wrapper">
        <br></br>
        {segments && selectedSegment && <LeaderboardsResults
                segments={segments}
                selectedType={selectedType}
                selectedSegment={selectedSegment}
                setLoading={setLoading}
          />}
      </div>
    </>
  )

  // return (
  //   <div className="leaderboard">
  //     <div class="wrapper">
  //       <div class="row">
  //         <Selectors />
  //         {segments && selectedSegment && <LeaderboardsResults
  //             segments={segments}
  //             selectedType={selectedType}
  //             selectedSegment={selectedSegment}
  //             setLoading={setLoading}
  //         />}
  //       </div>
  //     </div>
  //     <div class="loading-img" style={{display: (loading ? 'block' : 'none')}}></div>
  //   </div>
  // );
};
